import './nameDialog.css'
import { GUID } from '../Services/ServiceTypes'
import { FolderNode, getNodeById } from '../WooNotes/folders'
import { IEditorAttachment } from '../Services/ServiceEditor'

export interface IEditorAttachmentToBeRemoved {
  nodeId: GUID
  editorAttachment: IEditorAttachment | undefined
}

type Props = {
  nodeId: GUID | undefined
  editorAttachment: IEditorAttachment | undefined
  folderNodes: FolderNode[]
  onOK: () => void
  onCancel: () => void
}

export const ConfirmRemoveAttachmentDialog = ({ nodeId, editorAttachment, folderNodes, onOK, onCancel }: Props) => {
  if (!nodeId || !editorAttachment) return null

  const node = getNodeById(folderNodes, nodeId)
  if (!node) return null

  return (
    <div className="dialog-root">
      <div className="dialog-backdrop" onClick={onCancel} />

      <div className="dialog">
        <h3>
          Are you sure you want to delete attachment {editorAttachment.Filename} for node {node.name}?
        </h3>

        <div className="actions">
          <button onClick={onCancel}>Cancel</button>
          <button onClick={() => onOK()}>OK</button>
        </div>
      </div>
    </div>
  )
}
